import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Checkbox } from "@/components/ui/checkbox";
import { FormElement } from "../types";

interface ChoiceInputProps {
  element: FormElement;
  value: string;
  onChange: (value: string) => void;
}

export const ChoiceInput = ({ element, value, onChange }: ChoiceInputProps) => {
  const selectedValues = value ? value.split(',') : [];

  if (element.isMultiple) {
    return (
      <div className="space-y-2">
        <Label>
          {element.title}
          {element.required && <span className="text-red-500 ml-1">*</span>}
        </Label>
        <div className="space-y-2">
          {element.options?.map((option) => (
            <div key={option} className="flex items-center space-x-2">
              <Checkbox
                id={`${element.id}-${option}`}
                checked={selectedValues.includes(option)}
                onCheckedChange={(checked) => {
                  const newValues = checked
                    ? [...selectedValues, option]
                    : selectedValues.filter((v) => v !== option);
                  onChange(newValues.join(','));
                }}
              />
              <Label htmlFor={`${element.id}-${option}`}>{option}</Label>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <Label>
        {element.title}
        {element.required && <span className="text-red-500 ml-1">*</span>}
      </Label>
      <RadioGroup value={value} onValueChange={onChange}>
        {element.options?.map((option) => (
          <div key={option} className="flex items-center space-x-2">
            <RadioGroupItem value={option} id={`${element.id}-${option}`} />
            <Label htmlFor={`${element.id}-${option}`}>{option}</Label>
          </div>
        ))}
      </RadioGroup>
    </div>
  );
};